<top-bar-tabs></top-bar-tabs>
<mat-sidenav-container>
  <div class="container">
    <div class="row" *ngIf="project">
      <div class="col-12">
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title class="page-title">{{
              project.name
            }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="row align-top">
              <div *ngFor="let column of topDealInfo" class="col-md-3">
                <ul class="deal-info-column">
                  <li *ngFor="let field of column" class="field">
                    <ng-container *ngIf="field.name !== 'Co-Sponsor'">
                      <div *ngTemplateOutlet="default; context: {field: field}"></div>
                    </ng-container>
                    <ng-container *ngIf="field.name == 'Co-Sponsor'">
                      <div *ngTemplateOutlet="cosponsor; context: {field: field}"></div>
                    </ng-container>
                  </li>
                </ul>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="row" *ngIf="project?.projectCredits">
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title class="sub-title">Outlets</mat-card-title>
        </mat-card-header>
        <credit-outlet-table [projectCredits]="project?.projectCredits ?? []">
        </credit-outlet-table>
      </mat-card>
    </div>
    <div class="row gutters align-top" *ngIf="project && project?.id?.length">
      <div class="col-md-6">
        <deal-terms
          [readOnly]="true"
          [projectId]="project.id"
          [hideTitle]="true"></deal-terms>
      </div>
      <div class="col-md-6">
        <dispositions-details [projectId]="project.id"></dispositions-details>
      </div>
    </div>
    <div class="row">
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title class="sub-title">Dispositions</mat-card-title
          ><button
            *ngIf="
              projectId &&
              !!(dealDispositionService.permission$ | async)?._create
            "
            class="create-disposition-button"
            (click)="createDisposition()">
            <mat-icon inline>add</mat-icon>
          </button>
        </mat-card-header>
        <mat-card-content class="dispositions-section-content">
          <disposition-section></disposition-section>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</mat-sidenav-container>

<ng-template #default let-field="field">
  <span class="label">{{ field.name }}: </span>
  <span
    class="value"
    *ngIf="field.value?.__typename; else plain">
                        <contact-link [subject]="field.value"></contact-link>
                      </span>
    <ng-template #plain>
        <span *ngIf="field.value" class="value">{{
            field.value
          }}</span>
    </ng-template>
  <span *ngIf="!field.value" class="value">&mdash;</span>
</ng-template>

<ng-template #cosponsor let-field="field">
  <span class="label"> {{ field.name }}:</span>
  <ul *ngIf="field.value.length>0">
    <li *ngFor="let val of field.value" style="list-style: disc">
      <span class="value" *ngIf="val?.__typename; else plain">
         <contact-link [subject]="val"></contact-link>
      </span>
      <ng-template #plain>
          <span *ngIf="val" class="value">{{
              val
            }}</span>
      </ng-template>
    </li>
  </ul>
  <span *ngIf="field.value.length == 0" class="value">&mdash;</span>
</ng-template>
